import { useContext } from "react";
import { ReloadContext } from "../contexts/ReloadContext";

export function useReload() {
    const context = useContext(ReloadContext);
    if (!context) {
        throw new Error("useReload must be used within ReloadProvider");
    }
    return context;
}
